<!-- Copy of app/javascript/components/activities/ActivitiesHourRow.vue. Stripped down to just use the necessary
components for the getting_started review_screenshots substep. -->

<template>
  <div class="hour">
    <div class="row details">
      <div class="col-xs-12">
        <div class="rounded-checkbox-wrapper checkbox-md select-row-wrapper">
          <input
            v-model="selected"
            class="not-clickable"
            type="checkbox"
          />
          <label></label>
        </div>
        <div class="action-hover">
          <div class="inline-block hour-range">{{ hourRange }}</div>
          <span>Total time worked:</span>
          <span> </span>
          <span class="hourly_total">{{ hour.tracked | formatDuration }}</span>
        </div>
      </div>
    </div>
    <div class="row row-activity">
      <div class="col-xs-12">
        <div class="row">
          <div
            v-for="activity in hour.activities"
            :key="activity.id"
            class="col-lg-2 col-md-3 col-sm-4 col-xs-6 margin-bottom-xs"
          >
            <ActivitiesBlock
              :activity="activity"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { formatDatetimeRange, parseInternalDatetime } from '~/utils/time_utils';
  import ActivitiesBlock from './ActivitiesBlock.vue';

  export default {
    name: 'ActivitiesHourRow',
    components: {
      ActivitiesBlock,
    },
    props: {
      hour: {
        type: Object,
        required: true,
      },
    },
    computed: {
      hourRange() {
        const start = parseInternalDatetime(this.hour.starts_at);
        const stop = moment(start).add(1, 'hour');

        return formatDatetimeRange(start, stop, { style: 'time' });
      },
      screenshots() {
        return this.hour.activities.reduce((ak, cur) => ak.concat((cur && cur.screens) || []), []);
      },
      validActivities() {
        return this.hour.activities.filter((activity) => activity);
      },
      allTimeSlots() {
        return this.validActivities.map((activity) => ({
          timeSlot: activity.time_slot,
          screens: activity.screens,
          tracked: activity.tracked,
          projects: activity.project_names,
        }));
      },
      allSelected() {
        return !this.allTimeSlots.some((timeSlot) => ![].includes(timeSlot.timeSlot));
      },
      selected: {
        get() {
          return this.allSelected;
        },
        set() {
          if (this.allSelected) {
            this.deselectTimeSlots(this.allTimeSlots.map((ts) => ts.timeSlot));
          } else {
            this.selectTimeSlots(this.allTimeSlots);
          }
        },
      },
    },
  };
  </script>
